<script setup lang="ts">
    import type { FeatureVideoData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Asset widget for images, youtube videos or background videos
     * value contains a list of assets (otherwise rendered as gallery)
     * in case of an image, we need an image observer to check if the image is actually in the viewport before we load it
     */

    const props = defineProps<IWidgetProps<FeatureVideoData>>();
    const { data } = useWidget(props);
</script>
<template>
    <atm-grid class="cms-feature-video-widget relative mt-8">
        <atm-asset
            class="col-span-2 md:col-span-6"
            :data="data.video"
            sizes="100vw md:1024px lg:1264px" />
        <div class="col-span-2 flex items-center md:col-span-6">
            <cms-content-controller
                :data="data.description"
                no-grid />
        </div>
    </atm-grid>
</template>
